import { useQuery } from "@tanstack/react-query";
import { useDirectus } from "../providers";
import {
  getPropAvailability,
  getTotalDeliveredAmount,
  getTotalWithdrawAmount,
} from "../services/props";

export function useTotalPropDeliveries({ propId }: { propId: string }) {
  const { client } = useDirectus();

  return useQuery({
    queryKey: ["total-prop-recharges", propId],
    queryFn: async () => {
      const total = await getTotalDeliveredAmount(client, propId);
      return total;
    },
    enabled: !!propId,
  });
}

export function useTotalPropWithdrawals({ propId }: { propId: string }) {
  const { client } = useDirectus();
  return useQuery({
    queryKey: ["total-prop-withdrawals", propId],
    queryFn: async () => {
      const total = await getTotalWithdrawAmount(client, propId);
      return total;
    },
    enabled: !!propId,
  });
}

export function usePropAvailability(propId: string) {
  const { client } = useDirectus();
  return useQuery({
    queryKey: ["prop-availability", propId],
    queryFn: async () => {
      const result = await getPropAvailability(client, propId);
      return result;
    },
    enabled: !!propId,
  });
}
